import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { Envelope } from '../stripeFeesQuery/types';
import { responseHandler } from '../utils';
import { GuestModulesBackfillHistoryItem } from './types';

export const GUEST_MODULES_BACKFILLS_QUERY_KEY = 'guest-modules-backfills';

interface ListResponse {
  runs: GuestModulesBackfillHistoryItem[];
}

/**
 * Historia uruchomień backfillu (co, kiedy, kto, wynik). Endpoint listy
 * serializuje daty do ISO, więc `startedAt`/`finishedAt` są tu stringami.
 */
export const useGuestModulesBackfills = (
  limit = 50,
): UseQueryResult<GuestModulesBackfillHistoryItem[], AxiosError> => useQuery<
  GuestModulesBackfillHistoryItem[],
  AxiosError
>({
  queryKey: [GUEST_MODULES_BACKFILLS_QUERY_KEY, limit],
  retry: 0,
  staleTime: 30_000,
  queryFn: async () => {
    const response = await axiosInstance.get<Envelope<ListResponse>>(
      `/v3-listGuestModulesBackfills?limit=${limit}`,
    );
    return responseHandler(response).data.runs;
  },
});
